import(/* webpackMode: "eager", webpackExports: ["default"] */ "/code/components/design-studio/DesignStudioPage.js");
